import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
  withCredentials: true,
});

// Endpoints that must NOT have Authorization attached
// Support both /auth/* and /api/auth/* to avoid mismatches.
const NO_AUTH_PATHS = [
  "/auth/login",
  "/auth/register",
  "/auth/forgotPassword",
  "/auth/resetPassword",
  "/auth/verify-email",

  "/api/auth/login",
  "/api/auth/register",
  "/api/auth/forgotPassword",
  "/api/auth/resetPassword",
  "/api/auth/verify-email",
];

const isAuthPath = (url) => {
  const u = String(url || "");
  return NO_AUTH_PATHS.some((p) => u.startsWith(p)) || /\/auth\//.test(u);
};

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    const url = String(config.url || "");
    const shouldSkipAuth = isAuthPath(url);

    config.headers = config.headers || {};

    if (!shouldSkipAuth && token) {
      if (typeof config.headers.set === "function") {
        config.headers.set("Authorization", `Bearer ${token}`);
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } else {
      // ensure no stale auth header on auth endpoints
      if (typeof config.headers.delete === "function") {
        config.headers.delete("Authorization");
      } else {
        delete config.headers.Authorization;
      }
    }

    // Debug logs only in development
    if (process.env.NODE_ENV !== "production") {
      console.log(
        `Axios request: [${(config.method || "GET").toUpperCase()}] ${config.baseURL}${config.url}`
      );
      console.log("Headers:", config.headers);
      console.log("Data:", config.data);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (res) => {
    if (process.env.NODE_ENV !== "production") {
      console.log(
        `Axios response: [${(res.config.method || "GET").toUpperCase()}] ${res.config.url} -> ${res.status}`
      );
    }
    return res;
  },
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url;

    console.error(
      `Axios response error: ${url} -> ${status}`,
      err?.response?.data || err.message
    );

    // DO NOT auto logout or redirect here
    return Promise.reject(err);
  }
);

export default instance;